import ACTIONS from "../constants/actions";

const {
  GET_LEAVE_HISTORY_BY_TOKEN,
  GET_LEAVE_HISTORY_BY_TOKEN_SUCCESS,
  GET_LEAVE_HISTORY_BY_TOKEN_FAIL,
  GET_LEAVE_HISTORY_DETAIL_BY_TOKEN,
  GET_LEAVE_HISTORY_DETAIL_BY_TOKEN_SUCCESS,
  GET_LEAVE_HISTORY_DETAIL_BY_TOKEN_FAIL,
} = ACTIONS;

const initialState = {
  isLoadingLeaveHistoryByToken: false,
  leaveHistoryByToken: [],
  types: [],
  isLoadingLeaveHistoryDetailByToken: false,
  leaveHistoryDetailByToken: [],
};

const leaveHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEAVE_HISTORY_BY_TOKEN:
      return {
        ...state,
        isLoadingLeaveHistoryByToken: true,
      };
    case GET_LEAVE_HISTORY_BY_TOKEN_SUCCESS:
      return {
        ...state,
        isLoadingLeaveHistoryByToken: false,
        leaveHistoryByToken: action.payload.months,
        types: action.payload.types,
      };
    case GET_LEAVE_HISTORY_BY_TOKEN_FAIL:
      return {
        ...state,
        isLoadingLeaveHistoryByToken: false,
      };

    case GET_LEAVE_HISTORY_DETAIL_BY_TOKEN:
      return {
        ...state,
        isLoadingLeaveHistoryDetailByToken: true,
      };
    case GET_LEAVE_HISTORY_DETAIL_BY_TOKEN_SUCCESS:
      return {
        ...state,
        isLoadingLeaveHistoryDetailByToken: false,
        leaveHistoryDetailByToken: action.payload,
      };
    case GET_LEAVE_HISTORY_DETAIL_BY_TOKEN_FAIL:
      return {
        ...state,
        isLoadingLeaveHistoryDetailByToken: false,
      };

    default:
      return state;
  }
};
export default leaveHistoryReducer;
